<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="ch06"><span><a href="#/Contents#ch-06"><span class="line">FEARS AND PHOBIAS OF THE FAMOUS</span></a></span></h2>
<p class="center"><span><a id="page_12"><i>Scared of spiders? Afraid of flying? You’re not alone.</i></a></span></p><a id="page_12">
<p class="spx1">•<span class="space"></span>If the idea of flying in an aircraft at several hundred miles per hour makes you queasy, you’re in good company. Author Ray Bradbury—whose heroes rode around in spaceships—was afraid of flying. So were former president Ronald Reagan, French statesman Georges Clemenceau, and singer Johnny Cash. (Cash, we’ve heard, was also afraid of snakes.)</p>
<p class="spx">•<span class="space"></span>The list of people afraid of cats includes a lot of famous and powerful men: playwright William Shakespeare and leaders Napoléon, Julius Caesar, Benito Mussolini, Alexander the Great, and Dwight Eisenhower.</p>
<p class="spx">•<span class="space"></span>Composer Frédéric-François Chopin and author Hans Christian Andersen were both afraid of being buried alive. Anderson was so fearful that he had a sign that he set at the side of his bed when he retired for the night. The sign said he only <i>looked</i> dead.</p>
<p class="spx">•<span class="space"></span>Scientist and serious ding-a-ling Nikola Tesla was afraid of pearl earrings on women and any hotel room number or floor divisible by three.</p>
<p class="spx">•<span class="space"></span>Adolf Hitler was claustrophobic; so was Ronald Reagan. Surprisingly enough, magician Harry Houdini hated tight spaces, which makes his daring feats seem even more courageous.</p>
<p class="spx">•<span class="space"></span>Austrian neurologist Sigmund Freud, who was bound to have at least one phobia, was afraid of ferns.</p>
<p class="spx">•<span class="space"></span>Sir Laurence Olivier, arguably the greatest actor of the 20th century, had horrible stage fright.</p>
<p class="spx">•<span class="space"></span>Indian nationalist Mahatma Gandhi was afraid of the dark.</p>
<p class="spx">•<span class="space"></span>Industrialist Howard Hughes took his fear of germs to the extreme; it’s been said that he’d burn his clothing if someone he met was ill. (It’s amazing that he and actress Katharine Hepburn got along. She was afraid of fire.) Actress Joan Crawford was said to be afraid of germs, too.</p>
<p class="spx">•<span class="space"></span>Director Alfred Hitchcock was afraid of eggs. “Blood is jolly, red,” he once said. “But egg yolk is yellow, revolting.”</p>
<p class="center-box"><span><b>Billiards was introduced to America by the Spaniards in St. Augustine, Florida, in 1565.</b></span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter06.vue?7bd97f06